<template>
  <div class="list-landing">
    <sc-placeholder name="jss-list-landing" :rendering="rendering" />
  </div>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-List-Landing',
  components: {
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.list-landing {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0;
  @include padding-x-thin;
  justify-content: space-between;

  @include desktop-up {
    margin-bottom: 3rem;
  }
}
</style>
